export default "__VITE_ASSET__e3006ed5__"